export enum WorkingHours {
  DEFAULT = "8",
  PART_TIME = "4",
}
